const jsStringEscape = require("js-string-escape");
const userLocales = require("get-user-locale");
const util = require("util");

const locales = userLocales.getUserLocales();

// THE ENGLISH STRINGS ARE NOW IN the file named strings-en-US.js

const getLocaleString = function(key) {
    let localizedStrings, string;

    for (let i = 0; i < locales.length; i++) {
        try {
            localizedStrings = require("./strings-" + locales[i]);
        }
        catch (error) {
            localizedStrings = null;
        }

        if (localizedStrings) {
            string = localizedStrings.strings[key];
            if (string) {
                return string;
            }
        }
    }

    let enStrings = require("./strings-en-US");
    return enStrings.strings[key];
};

exports.getString = function (key, ...params) {
    if (!key || key.length === 0 || key.trim() === "") {
        return null;
    }

    var value = getLocaleString(key);
    if (!value || value.length === 0 || value.trim() === "") {
        return null;
    }

    return this.format(value, ...params);
};

exports.isBlank = function (value) {
    return !value || value.length === 0 || value.trim().length === 0;
};

// This function exists in case we need to add additional functionality for
// quoting strings in the future.
exports.quote = function (str) {
    if (str === undefined) {
        return undefined;
    }
    if (str === null) {
        return null;
    }
    return jsStringEscape(str);
};

exports.format = function (format, ...params) {
    if (params) {
        return util.format(format, ...params);
    } else {
        return util.format(format);
    }
};

exports.base64Encode = function (str) {
    return Buffer.from(str).toString("base64");
};
